<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterSearch
        :fetchData="fetchRealEstateUsers"
        label="searchByUserOrEmail"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import { mapActions } from 'vuex'

export default {
  name: 'RealEstateUserFilters',

  components: { FilterSearch },

  methods: {
    ...mapActions(['fetchRealEstateUsers']),
  },
}
</script>
